export default __webpack_public_path__ + "static/media/photo--lg--misc-12.06016cd4.jpg";